// extracted by mini-css-extract-plugin
module.exports = {"tab-section":"ModelUseCases_tab-section__2gu06","active-usecase-button":"ModelUseCases_active-usecase-button__1Jab_","disabled-button":"ModelUseCases_disabled-button__eGCYq"};